import { PageProps } from "@/types/page";
import dataLayerUserData from "@/utils/dataLayer";

export function trackCreatedAccount(props: PageProps): void {
    if (!props.justRegistered || !props.user) {
        return;
    }

    dataLayer.push({
        event: "created_account",
        ...dataLayerUserData(props.user),
    });
}
